import { memo } from 'react';
import Slider from '../../../SliderTwo';
import Button from '../../../Button';
import PublicationStatusBadge from '../PublicationStatusBadge/PublicationStatusBadge';
import { images } from '../../../../constants/images';
import { PublicationImageSliderProps } from '../../interfaces';
import styles from '../../publicationDetail.module.scss';

const PublicationImageSlider = ({
  type,
  brand,
  publication,
  selectedVersion,
  onLinzeCheckClick,
  vehicleTypeSelected,
  loading
}: PublicationImageSliderProps) => {
  const getSliderImages = () => {
    if (brand && selectedVersion && publication?.vehicles) {
      const selectedVehicle = publication.vehicles.find((v: any) => v._id === selectedVersion);
      const allImages = [];

      // Primero agregamos las imágenes principales de la publicación
      const picturesArray = publication?.pictures?.gallery || publication?.pictures || [];
      if (picturesArray && picturesArray.length > 0) {
        const mainImages = picturesArray.map((item: any, index: number) => (
          <img
            loading="lazy"
            key={`main-${index}`}
            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
            className={publication?.paused && styles.paused}
            alt={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
            title={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
          />
        ));
        allImages.push(...mainImages);
      }

      // Luego agregamos las imágenes del vehículo seleccionado
      if (selectedVehicle?.images && selectedVehicle.images.length > 0) {
        const vehicleImages = selectedVehicle.images.map((item: any, index: number) => (
          <img
            loading="lazy"
            key={`vehicle-${index}`}
            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
            className={publication?.paused && styles.paused}
            alt={`${publication?.title} ${selectedVehicle.version || selectedVehicle.name || ''} año ${selectedVehicle.year || publication?.year}`}
            title={`${publication?.title} ${selectedVehicle.version || selectedVehicle.name || ''} año ${selectedVehicle.year || publication?.year}`}
          />
        ));
        allImages.push(...vehicleImages);
      }

      return allImages.length > 0 ? allImages : [1].map((_: any, index: number) => (
        <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" title="No image found publication linzecar"/>
      ));
    }

    const picturesArray = publication?.pictures?.gallery || publication?.pictures || [];
    return picturesArray && picturesArray.length > 0
      ? picturesArray.map((item: any, index: number) => (
          <img
            loading="lazy"
            key={index}
            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
            className={publication?.paused && styles.paused}
            alt={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
            title={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
          />
        ))
      : [1].map((_: any, index: number) => (
          <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" title="No image found publication linzecar" />
        ));
  };

  return (
    <div className={styles.sliderContainer}>

      {/* Status Badge */}
      <PublicationStatusBadge
        publication={publication}
        type={type}
      />

      <Slider
        className={styles.slider}
        type="thumbs"
        options={getSliderImages()}
        pagination
        typePublication={type}
        loading={loading && (!Array.isArray(publication?.pictures?.gallery || publication?.pictures) && !(publication?.pictures?.gallery || publication?.pictures)?.length)}
      />
    </div>
  );
};

export default memo(PublicationImageSlider);
